import { ApplicationElement, html } from '@effectivastudio/lit-components';
import { ResizeController } from '@lit-labs/observers/resize-controller.js';
import style from './style.lit.css';
import '@effectivastudio/lit-components/components/grid/element.js';

/**
 * Navigation panel provides a list of navigation items.
 *
 * @prop isDesktop - Internal property
 *
 * @slot default - For panel content
 */

export default class NavigationPanel extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  resizeObserver = new ResizeController(this, {
    callback: () => this.handleResize(),
  });

  /** @internal */
  get grid() {
    return this.shadowRoot.querySelector('ef-grid');
  }

  /** @internal */
  get isDesktop() {
    return window.innerWidth >= 992;
  }

  /** @internal */
  get gap() {
    return this.isDesktop ? 'sm' : 'xs';
  }

  /** @internal */
  get col() {
    return this.isDesktop ? '3' : '1';
  }

  handleResize() {
    this.grid.col = this.col;
    this.grid.gap = this.gap;
  }

  render() {
    return html`
      <ef-grid rounded="true">
        <slot></slot>
      </ef-grid>
    `;
  }
}

customElements.get('xs-nav-panel') ||
  customElements.define('xs-nav-panel', NavigationPanel);
